import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  searchResult: undefined,
  products: undefined,
  agentTypes: undefined
}

export default {
  state,
  actions,
  getters,
  mutations
}
